export function getFromQuery(key: string, searchString?: string): string {
  const query = sanitizedHashQueryUri(
    searchString ? searchString : window.location.search,
  );

  const vars = query.split('&');

  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');

    if (decodeURIComponent(pair[0]) === key) {
      return decodeURIComponent(pair[1]);
    }
  }
}
/**
 * Strips the last forward slash of the url slug and returns it
 */
export function getSanitizedSlug(pathname: string): string {
  if (!pathname) {
    return;
  }
  if (pathname.charAt(pathname.length - 1) === '/') {
    pathname = pathname.slice(0, -1);
  }
  return pathname;
}

const HTTP_QUERY_STRING_REGEX = /\?([&]*\w+=[^&]+)+/;

function sanitizedHashQueryUri(query: string): string {
  let rv = query;

  if (isHashQueryUri(query)) {
    rv = query.replace(
      HTTP_QUERY_STRING_REGEX,
      (match) => `&${match.slice(1)}`,
    );
  }

  return rv.slice(1);
}

function isHashQueryUri(query: string): boolean {
  return query[0] === '#';
}
